import { ArrowDropDown } from "@mui/icons-material";
import { Box } from "@mui/material";
import { MouseEventHandler, ReactNode } from "react";

interface SidebarSectionHeaderProps {
  actions?: ReactNode;
  isExpanded?: boolean;
  isCollapsed?: boolean;
  onContextMenu?: MouseEventHandler<HTMLElement>;
  onToggle?: () => void;
  title: string;
}

export const SidebarSectionHeader = ({
  actions,
  isExpanded = true,
  isCollapsed = false,
  onContextMenu,
  onToggle,
  title,
}: SidebarSectionHeaderProps) => {
  const drawerIconColor = "rgba(0, 0, 0, 0.54)";

  if (isCollapsed) {
    return <Box aria-hidden="true" className="mx-4 my-3 h-px bg-slate-200" />;
  }

  if (onToggle) {
    return (
      <Box className="pl-5">
        <Box className="flex items-center gap-2 min-w-0">
          <Box
            aria-expanded={isExpanded}
            className={`flex shrink-0 items-center gap-1 overflow-hidden text-[15px] font-medium text-black`}
            component="button"
            onClick={onToggle}
            onContextMenu={onContextMenu}
            sx={{
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              padding: 0,
              textAlign: "left",
              height: "26px",
            }}
            type="button"
          >
            <span>{title}</span>
            <Box
              component="span"
              style={{
                display: "inline-flex",
                transform: isExpanded ? "rotate(0deg)" : "rotate(-90deg)",
                transition: "transform 200ms",
              }}
            >
              <ArrowDropDown sx={{ color: drawerIconColor, fontSize: 18 }} />
            </Box>
          </Box>
          {actions ? (
            <Box className="flex items-center flex-1 justify-end">
              {actions}
            </Box>
          ) : null}
        </Box>
      </Box>
    );
  }

  return (
    <Box className="px-4 pb-1 pt-5">
      <Box className="flex items-center gap-2 justify-between">
        <div
          className="flex min-w-0 items-center gap-1 text-[15px] font-medium text-black"
          onContextMenu={onContextMenu}
        >
          <span>{title}</span>
          <ArrowDropDown sx={{ color: drawerIconColor, fontSize: 18 }} />
        </div>
        {actions ? <Box className="flex items-center">{actions}</Box> : null}
      </Box>
    </Box>
  );
};
